/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useContext } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import BottomNav from "./BottomNav";
import Soon from "./Soon";
import { CareGiverContext } from "../context/CareGiverContext";
import { useTheme } from "../context/ThemeContext";

const Layout = ({ children }) => {
  const { isDarkMode } = useTheme();
  const { profileData } = useContext(CareGiverContext);

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  const role = "caregiver";
  const profile = profileData;

  const user = {
    name: profile?.name || "Caregiver",
    email: profile?.email || "caregiver@mogzit.com",
    avatar: profile?.image || "https://picsum.photos/200/200?random=1",
    role,
  };

  const handleUpgradeClick = () => {
    setShowPremiumModal(true);
  };

  return (
    <div
      className={`flex h-screen w-full overflow-hidden ${
        isDarkMode
          ? "bg-dark-background text-dark-text"
          : "bg-background text-text"
      }`}
    >
      {/* Sidebar — hidden on mobile, visible on md+ */}
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        isMobileOpen={isMobileMenuOpen}
        closeMobile={() => setIsMobileMenuOpen(false)}
        user={user}
        onUpgradeClick={handleUpgradeClick}
      />

      {/* Main Content */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <Navbar user={user} onMenuClick={() => setIsMobileMenuOpen(true)} />

        <main
          className={`flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 pb-20 md:pb-6 lg:pb-8 ${
            isDarkMode ? "bg-dark-surface" : "bg-card"
          }`}
        >
          {children}
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <BottomNav />

      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div
          className={`fixed inset-0 z-20 md:hidden ${
            isDarkMode ? "bg-black/70" : "bg-black/50"
          }`}
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Premium Feature Modal */}
      <Soon
        isOpen={showPremiumModal}
        onClose={() => setShowPremiumModal(false)}
        isDarkMode={isDarkMode}
      />
    </div>
  );
};

export default Layout;
